/**
 * @generated SignedSource<<2fb496f9473123b3799147540af45c6d>>
 * @relayHash f3aba2cd450bb5d1b077e19085383784
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bbf19cfe3036aee93889e132713cee04cbef5422ceff811666a4b6709089060e

var node = function () {
  var v0 = [{
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "pageId"
    }],
    v1 = [{
      "kind": "Variable",
      "name": "id",
      "variableName": "pageId"
    }],
    v2 = {
      "kind": "ScalarField",
      "name": "id"
    },
    v3 = {
      "kind": "ScalarField",
      "name": "title"
    };
  return {
    "fragment": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Fragment",
      "name": "hubHomeQuery",
      "selections": [{
        "concreteType": "ConfluenceQueryApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [{
          "args": v1 /*: any*/,
          "concreteType": "ConfluencePage",
          "kind": "LinkedField",
          "name": "page",
          "plural": false,
          "selections": [v2 /*: any*/, v3 /*: any*/, {
            "kind": "FragmentSpread",
            "name": "body_AtlassianHubStudio"
          }]
        }]
      }],
      "type": "Query"
    },
    "kind": "Request",
    "operation": {
      "argumentDefinitions": v0 /*: any*/,
      "kind": "Operation",
      "name": "hubHomeQuery",
      "selections": [{
        "concreteType": "ConfluenceQueryApi",
        "kind": "LinkedField",
        "name": "confluence",
        "plural": false,
        "selections": [{
          "args": v1 /*: any*/,
          "concreteType": "ConfluencePage",
          "kind": "LinkedField",
          "name": "page",
          "plural": false,
          "selections": [v2 /*: any*/, v3 /*: any*/, {
            "concreteType": "ConfluenceBodies",
            "kind": "LinkedField",
            "name": "body",
            "plural": false,
            "selections": [{
              "concreteType": "ConfluenceBody",
              "kind": "LinkedField",
              "name": "atlasDocFormat",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "name": "value"
              }]
            }, {
              "kind": "ScalarField",
              "name": "excerpt"
            }]
          }]
        }]
      }]
    },
    "params": {
      "id": "bbf19cfe3036aee93889e132713cee04cbef5422ceff811666a4b6709089060e",
      "metadata": {},
      "name": "hubHomeQuery",
      "operationKind": "query",
      "text": null
    }
  };
}();
node.hash = "fbe602a24fd325f3d2ed194420d69f55";
export default node;